// @flow
import React from 'react';

import type { TitleProps } from './types';
import S from './styles';

const Title = ({ title, children }: TitleProps) => <S.Title title={title}>{children}</S.Title>;

export default Title;
